<template>
  <!-- 编辑弹窗 -->
  <el-dialog
    :title="title"
    :visible.sync="temp.dialogFlag"
    :modal="true"
    :modal-append-to-body="false"
    top="2%"
  >
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="100px"
      style="width: 60%; margin-left: 100px"
    >
      <el-form-item label="旧密码" prop="password">
        <el-input v-model="temp.password" placeholder="请输入密码" show-password />
      </el-form-item>

      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="temp.newPassword" placeholder="请输入密码" show-password />
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="temp.confirmPassword" placeholder="请输入密码" show-password />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="temp.dialogFlag = false"> 取消 </el-button>
      <el-button type="primary" @click="updateUsersPassword()"> 确认 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateUsersPassword } from '@/api/user'

import { MessageBox } from 'element-ui'
import store from '@/store'
import { checkPassword } from '@/utils'

export default {
  name: 'UpdatePassword',
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.temp.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      title: '修改用户密码',
      temp: {
        dialogFlag: false,
        password: '',
        newPassword: '',
        confirmPassword: '',
      },

      // 校验规则
      rules: {
        password: [{ required: true, message: '旧密码必填', trigger: 'blur' }],
        newPassword: [
          {
            required: true,
            validator: function (rule, value, callback) {
              var result = checkPassword(value)
              console.log('密码强度', result)
              if (result.score <= 4) {
                callback(new Error(result.msg))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
    open() {
      this.temp.dialogFlag = true
    },
    close() {
      this.temp.dialogFlag = false
    },
    // 修改密码
    updateUsersPassword() {
      this.$refs['dataForm'].validate((valid) => {
        updateUsersPassword(this.temp).then((response) => {
          this.temp.dialogFlag = false
          MessageBox.confirm('修改成功,请重新登录', '退出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
        })
      })
    },
  },
}
</script>
